export enum Header {
  Authorization = 'Authorization',
  Accept = 'Accept',
  ContentType = 'Content-Type',
}
